module.exports = __webpack_public_path__ + "img/banner2-2@1x.b5100c4d.jpg";